import { assets, contactInfo } from "../mock";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="wrap footer-grid">
        <div className="footer-brand">
          <img src={assets.logoWhite} alt="ODDA Corp." className="footer-brand__logo" />
          <p>Architecture, Design &amp; Development — considered, refined, enduring.</p>
        </div>
        <div className="footer-cols">
          <div>
            <span className="kicker">Studio</span>
            <p>{contactInfo.location}</p>
            <p>{contactInfo.hours}</p>
          </div>
          <div>
            <span className="kicker">Contact</span>
            <p>
              <a href={`mailto:${contactInfo.email}`} className="footer-link">
                {contactInfo.email}
              </a>
            </p>
            <p>{contactInfo.phone}</p>
          </div>
          <div>
            <span className="kicker">Follow</span>
            <p>
              <a
                href={contactInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link"
              >
                Instagram
              </a>
            </p>
            <p>Are.na</p>
          </div>
        </div>
      </div>
      <div className="wrap footer-base">
        <span>© {new Date().getFullYear()} ODDA Corp. All rights reserved.</span>
        <span>Made in Toronto</span>
      </div>
    </footer>
  );
};

export default Footer;
